import XcolumnFunc from "@/pcomponents/common/xcolumn/xcolumn/xcolumn_func";
//const xColumnArr=getXcolumnJson();

const getXcolumnJson=()=>{
  let initData:any={
    table:"word_inside",
    list_id:"word_inside_list",
    x_column_list_arr:[
      {"key":"a_word_type","name":"구분","width":"60","is_show":"1"},
      {"key":"a_title","name":"제목","width":"180","is_show":"1"},
      {"key":"row_view_word_count","name":"학습","width":"100","is_show":"1"},
      {"key":"row_view_user","name":"학습이력","width":"100","is_show":"1"},
      {"key":"row_view_preview","name":"미리보기","width":"100","is_show":"1"},
    ],
    list_opt_origin:{
      'now_page':1,
      'num_per_page':30,
      'order_id':'',
      'order_type':'',
      's_date_type':'',
      's_start_date':'',
      's_end_date':'',
      'sc':{},
      "is_add_idx_info":"1",
    },
    order_id_col_arr:[
      {"value":"","text":"없음"},
    ]
  };
  initData.pri_col_arr=["a_seq"];
  const xColumnArr:any=XcolumnFunc.getDefaultXcolumn(initData);
  xColumnArr.select_arr["a_word_type"]=[
    {"value":"","text":"전체"},
    {"value":"word","text":"단어"},
    {"value":"stc","text":"문장"},
  ];
  
  return xColumnArr;
};

export default getXcolumnJson;